import * as React from 'react';
import { PureIconContainer } from './utils/IconContainer';
var Magnifier = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Magnifier_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.59 12.286a7 7 0 1 1 .696-.696.505.505 0 0 1 .068.056l3.5 3.5a.5.5 0 0 1-.708.708l-3.5-3.5a.505.505 0 0 1-.057-.068ZM13 7A6 6 0 1 1 1 7a6 6 0 0 1 12 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Magnifier_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
export default Magnifier;